import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { faqItems } from '@/mocks/faq';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto max-w-3xl">
        <SectionHeading
          eyebrow="FAQ"
          title="观剧问答：追剧前最常被问到的几件事"
          desc="关于作品形式、观看顺序和剧情基调，这里集中回答一遍，方便你快速判断。"
          align="center"
        />

        <div className="mt-10 space-y-3">
          {faqItems.map((item, index) => {
            const isOpen = index === openIndex;
            return (
              <div key={item.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center gap-3 px-4 py-4 text-left md:px-5"
                  >
                    <span
                      className={`flex h-6 w-6 flex-none items-center justify-center rounded-full font-label text-xs ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      Q
                    </span>
                    <span className="flex-1 font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <i
                      className={`flex-none text-lg text-foreground-500 transition-transform ${
                        isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'
                      }`}
                    ></i>
                  </button>
                </h3>
                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                  <div className="overflow-hidden">
                    <p className="border-t border-background-200 px-4 py-4 pl-12 text-xs leading-loose text-foreground-700 md:px-5 md:text-sm">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}